import clsx from 'clsx';
import { Fragment, memo } from 'react';

import { Icon } from '@flintmint/web-shared/components/icon';
import { Divider } from '@flintmint/web-shared/components/divider';
import { Popover } from '@flintmint/web-shared/components/popover';

import { useNotesLinkedToTemplate } from '@/hooks/rxdb-models';
import { useNavigateWithSearch } from '@/hooks/use-navigate-with-search';

import { itemTypes } from '@/constants/item-types';

import styles from './linked-notes-list.module.scss';
import { appRoutes } from '@/constants/routes';

// TODO: Add keyboard navigation support. Consider reusing the logic from the menu component if it's reusable or can be refactored for shared use.
export const LinkedNotesList = memo((props: LinkedNotesProps) => {
  const { templateId } = props;

  const navigateWithSearch = useNavigateWithSearch();

  const { data, isLoading } = useNotesLinkedToTemplate(templateId);
  const linkedNotes = isLoading ? [] : data;

  return (
    <Popover
      placement="bottom"
      offset={[0, 10]}
      content={
        <ul className={styles.linkedNotesList}>
          {linkedNotes.map((note, index) => (
            <Fragment key={note.id}>
              <li
                role="button"
                onClick={() => {
                  navigateWithSearch(`${appRoutes.library}/${note.id}`);
                }}
              >
                <div>
                  <Icon type={itemTypes[note.variant].icon} size={16} />
                  <span>{note.name}</span>
                </div>
                <div>
                  <span className="ellipsis-text">{note.parsedContent.slice(0, 80)}</span>
                </div>
              </li>
              {index !== linkedNotes.length - 1 && (
                <li className={styles.divider}>
                  <Divider orientation="horizontal" />
                </li>
              )}
            </Fragment>
          ))}
        </ul>
      }
    >
      <div
        className={clsx(styles.linkedNotesChip, {
          [styles.empty]: !linkedNotes.length,
        })}
        data-testid="linked-notes-chip"
      >
        <Icon type="link-01" />
        <span>{linkedNotes.length ? `${linkedNotes.length} Linked Notes` : 'No linked notes'}</span>
      </div>
    </Popover>
  );
});

interface LinkedNotesProps {
  templateId: string;
}
